import { render, staticRenderFns } from "./Relacionados.vue?vue&type=template&id=5db8599a&scoped=true&lang=pug"
import script from "./Relacionados.vue?vue&type=script&lang=js"
export * from "./Relacionados.vue?vue&type=script&lang=js"
import style0 from "./Relacionados.styl?vue&type=style&index=0&id=5db8599a&prod&lang=stylus&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5db8599a",
  null
  
)

export default component.exports